// Citation regex pattern for matching [[^1]], [[^2]], etc.
export const CITATION_REGEX = /\[\[\^(\d+)\]\]/g;

/**
 * Preprocesses markdown message to convert citation syntax [[^1]]
 * into HTML-like tags that react-markdown can handle
 *
 * @param message - The markdown message containing citation syntax
 * @returns Processed message with citations converted to custom tags
 *
 */
export const preprocessMessageWithCitations = (message = ''): string => {
  if (typeof message !== 'string') {
    return '';
  }

  if (message.trim().length === 0) {
    return '';
  }

  return message.replace(CITATION_REGEX, (match, citationNum) => {
    return `<cite data-num="${citationNum}">${citationNum}</cite>`;
  });
};

/**
 * Checks if a message contains any citations
 *
 * @param message - The message to check
 * @returns True if the message contains citations, false otherwise
 */
export const hasCitations = (message: string): boolean => {
  return CITATION_REGEX.test(message);
};
